export const home_page_main = "/assets/backgrounds/home_page_main.png";
export const home_page_main_small = "/assets/backgrounds/home_page_main_small.png";

export const partner_1 = "/assets/backgrounds/partner_1.png";
export const partner_2 = "/assets/backgrounds/partner_2.png";
export const partner_3 = "/assets/backgrounds/partner_3.png";
export const how_is_event_going = "/assets/backgrounds/how_is_event_going.png";
export const contacts = "/assets/backgrounds/contacts.png";
export const instagram_qr = "/assets/backgrounds/instagram_qr.png";